<template>
  <button
    class="btn mb-0 btn-outline-secondary btn-md d-flex"
    :value="modelValue"
    @click.prevent="() => isActive = !modelValue"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    displayCheckbox: {
      type: Boolean,
      default: false
    }
  },

  emits: [
    'update:modelValue',
  ],

  computed: {
    isActive: {
      get() { return this.modelValue; },
      set(v) { 
        this.$emit('update:modelValue', v); }
    }
  },
}
</script>

<style scoped>
button[value="true"] {
  background: #4caf50;
  border-color: #4caf50;
  color: #fff;
}
</style>